export default class BlockAgencies {
    static init() {
        let sliders = document.querySelectorAll('.block-agencies .swiper');
        sliders.forEach((slider) => {
            this.slider(slider);
        });
    }

    static slider(slider) {
        const prev = slider.querySelector('.prev');
        const next = slider.querySelector('.next');
        let swiper = new Swiper(slider, {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 20,
            speed: 700,
            pagination: {
                el: slider.querySelector('.slider-cards-pagination'),
                type: 'bullets',
                clickable: true,
                dynamicBullets: false,
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                991: {
                    spaceBetween: 45
                }
            }
        });
    }
}
